import React from 'react';
import'./unlockedlevel.css'
import pic13 from '../../assets/pic13.png'
import { Link } from 'react-router-dom';

const Unlockedlevel = (props) => {
    return ( 
        <>           
        <Link  to={props.link} className='linkkkunlocked'>
                <div className='big-cont-next-level'>
                    <button className='button-next-levell'>
                        <div className='white-circle'>
                            <h2 className='number-level'>{props.numb}</h2>
                            <h2 className='number-level2'>{props.numb}</h2>
                        </div>
                    </button>
                          <div className='container-next-level'>
                         </div>
                        
                        <figure className='container-stars'>

                            <figure className='containerr-img-star2'>
                                <img className='small-star' src={pic13} alt='star'></img>
                            </figure>

                            <figure className='containerr-img-star'>
                                <img src={pic13} alt='star'></img>
                            </figure>

                            <figure className='containerr-img-star2'>
                                <img className='small-star' src={pic13} alt='star'></img>
                            </figure>

                        </figure>
                </div>
            </Link>
        </>
     );
}
 
export default Unlockedlevel;